import React, { useState } from 'react';

const NewsletterSignup = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | sending | success | error

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus('sending');
    try {
      const res = await fetch('/api/newsletter', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) throw new Error();
      setStatus('success');
      setEmail('');
    } catch {
      setStatus('error');
    }
  };

  if (status === 'success') {
    return (
      <div style={{
        padding: '20px 24px',
        border: '1px solid rgba(27,61,42,0.5)',
        borderRadius: '14px',
        background: 'rgba(27,61,42,0.1)',
      }}>
        <p style={{
          color: '#4ade80',
          fontFamily: "'Figtree', sans-serif",
          fontSize: '14px',
          fontWeight: '600',
          margin: 0,
        }}>
          You're in. Watch your inbox.
        </p>
      </div>
    );
  }

  return (
    <div>
      <h4 style={{
        color: 'rgba(255,255,255,0.4)',
        fontFamily: "'Figtree', sans-serif",
        fontSize: '11px',
        fontWeight: '600',
        letterSpacing: '0.2em',
        textTransform: 'uppercase',
        marginBottom: '12px',
      }}>Monthly Performance Brief</h4>
      <p style={{
        color: 'rgba(255,255,255,0.5)',
        fontFamily: "'Figtree', sans-serif",
        fontSize: '13px',
        lineHeight: '1.6',
        marginBottom: '16px',
      }}>
        Leadership frameworks, discipline systems, and strategy — delivered monthly.
      </p>
      <form onSubmit={handleSubmit} style={{ display: 'flex', gap: '8px' }}>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="your@email.com"
          required
          style={{
            flex: 1,
            background: 'rgba(255,255,255,0.04)',
            border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: '10px',
            padding: '10px 14px',
            color: '#ffffff',
            fontFamily: "'Figtree', sans-serif",
            fontSize: '13px',
            outline: 'none',
            minWidth: 0,
            transition: 'border-color 0.2s ease',
          }}
          onFocus={(e) => (e.target.style.borderColor = 'rgba(255,255,255,0.4)')}
          onBlur={(e) => (e.target.style.borderColor = 'rgba(255,255,255,0.1)')}
        />
        <button
          type="submit"
          disabled={status === 'sending'}
          style={{
            background: '#C8102E',
            color: '#ffffff',
            border: 'none',
            borderRadius: '10px',
            padding: '10px 18px',
            fontFamily: "'Figtree', sans-serif",
            fontSize: '13px',
            fontWeight: '600',
            cursor: status === 'sending' ? 'default' : 'pointer',
            whiteSpace: 'nowrap',
            opacity: status === 'sending' ? 0.7 : 1,
            transition: 'background-color 0.2s ease',
          }}
          onMouseEnter={(e) => { if (status !== 'sending') e.currentTarget.style.backgroundColor = '#a80d25'; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#C8102E'; }}
        >
          {status === 'sending' ? '...' : 'Subscribe'}
        </button>
      </form>
      {status === 'error' && (
        <p style={{
          color: '#ff6b7a',
          fontFamily: "'Figtree', sans-serif",
          fontSize: '12px',
          marginTop: '8px',
        }}>
          Could not subscribe. Please try again.
        </p>
      )}
    </div>
  );
};

export default NewsletterSignup;
